export const BASE_ENDPOINT = process.env.REACT_APP_BASE_ENDPOINT;
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;